import * as React from 'react'

export function ConditionIcon({
  fill = '#8E24AA',
  width = 24,
  height = 24,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-label="Condition icon"
      {...props}
    >
      <path
        d="M10 3V4.51L12 5.84L13.73 7H15V7.85L17 9.19V11H19V13H17V15H19V17H17V21H23V3H10ZM19 9H17V7H19V9Z"
        fill={fill}
      />
      <path
        d="M8.17 5.7002L1 10.4802V21.0002H6V13.0002H10V21.0002H15V10.2502L8.17 5.7002Z"
        fill={fill}
      />
    </svg>
  )
}
